<div class="nav-bar">
  <div class="nav-panel">
    <div class="header-position">
      <ukg-label class="nav-bar-text" type="tertiary" translate data-automation="stale_dated_checks_info_selected_items_count"
        [translateParams]="{ selectedCount: selectedStaleCheckItemsCount }">
        COMMON.SELECTED_ITEMS_COUNT
      </ukg-label>
    </div>
      <div class="header-position">
        <div>
          <ukg-button type="text" (click)="exportSelectedPays()" data-automation="stale_dated_checks_export_btn"
            [attr.aria-disabled]="!areAnyPaysSelected" [disabled]="!areAnyPaysSelected()"
            translate emphasis="mid" size="medium"> COMMON.BUTTON_EXPORT
          </ukg-button>
        </div>
      </div>
  </div>
  <div class="header-position">
    <div class="filter-position">
      <ssg-stale-check-filters (toggle)="showFilters=$event" style="height: 100%" class="flex-1-0-auto" data-automation="stale_dated_checks_filter_btn">
      </ssg-stale-check-filters>
    </div>
  </div>
</div>
  
<div class="display-notification">
  <ssg-notification-bar [userMessages]="userMessages" [notification]="notificationSubject.asObservable()"
    pageKey="stale_dated_checks-info-table" #staleDatedChecksInfoTableNotificationBar>
  </ssg-notification-bar>
</div>
  
<div style="position: relative;" class="datatable-position">
  <div>
    <div class="table-container flex-100">

      <ukg-data-table-container>
        <ukg-data-table [columnNames]="allColumns" (ukgDataTableSortChanged)="handleSort($event)"
          data-automation="stale_dated_checks-info-table">
          <table id="table">
            <thead id="head">
              <tr>
                <ng-container data-automation="stale_dated_checks-info-table-column-paySelected">
                  <ukg-th style="width:2%" data-automation="stale_dated_checks-info-table-header-paySelected">
                    <div class="checkbox">
                      <label for="select-all-pays" translate>
                        <input type="checkbox" id="select-all-pays"
                          data-automation="stale_dated_checks-info-table-header-paySelected-checkbox" [checked]="areAllPaysSelected()"
                          [indeterminate]="!areAllPaysSelected() && areAnyPaysSelected()"
                          (click)="clickAllPays($event.target.checked)" />
                      </label>
                    </div>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="stale_dated_checks-info-table-column-displayName">
                  <ukg-th style="width:10%" data-automation="stale_dated_checks-info-table-header-displayName" sort-key="displayName"
                    sortable>
                    <span data-automation="stale_dated_checks-info-table-header-displayName-label" translate>
                      STALE_DATED_CHECKS.COLUMN_NAME</span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="stale_dated_checks-info-table-column-employeeNumber">
                  <ukg-th style="width:10%" data-automation="stale_dated_checks-info-table-header-employeeNumber"
                    sort-key="employeeNumber" sortable>
                    <span data-automation="stale_dated_checks-info-table-header-employeeNumber-label" translate>
                      STALE_DATED_CHECKS.COLUMN_EMPLOYEE_NUMBER
                    </span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="stale_dated_checks-info-table-column-payGroup">
                  <ukg-th style="width:9%" data-automation="stale_dated_checks-info-table-header-payGroup"
                    sort-key="payGroup" sortable>
                    <span data-automation="stale_dated_checks-info-table-header-payGroup-label"
                      translate>STALE_DATED_CHECKS.COLUMN_PAY_GROUP</span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="stale_dated_checks-info-table-column-payUtcDate">
                  <ukg-th style="width:8%" data-automation="stale_dated_checks-info-table-header-payUtcDate" sort-key="payUtcDate"
                    sortable>
                    <span data-automation="stale_dated_checks-info-table-header-payUtcDate-label" translate>
                      STALE_DATED_CHECKS.COLUMN_PAY_DATE
                    </span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="stale_dated_checks-info-table-column-payItemNumber">
                  <ukg-th class="datatable-document-header" data-automation="stale_dated_checks-info-table-header-payItemNumber"
                    sort-key="checkNumber" sortable>
                    <span>
                      <span data-automation="stale_dated_checks-info-table-header-payItemNumber-label">
                        <span [innerHtml]="'STALE_DATED_CHECKS.COLUMN_CHECK_NUMBER' | translate">
                        </span>
                      </span>
                    </span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="stale_dated_checks-info-table-column-payItemAmount">
                  <ukg-th style="width:9%" data-automation="stale_dated_checks-info-table-header-payItemAmount"
                    sort-key="checkAmount" sortable>
                    <span data-automation="stale_dated_checks-info-table-header-payItemAmount-label" translate>
                      STALE_DATED_CHECKS.COLUMN_CHECK_AMOUNT
                    </span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="stale_dated_checks-info-table-column-staleDate">
                  <ukg-th style="width:9%" data-automation="stale_dated_checks-info-table-header-staleDate"
                    sort-key="staleDate" sortable>
                    <span data-automation="stale_dated_checks-info-table-header-staleDate-label" translate>
                      STALE_DATED_CHECKS.COLUMN_STALE_DATE
                    </span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="stale_dated_checks-info-table-column-statusText">
                  <ukg-th style="width:9%" data-automation="stale_dated_checks-info-table-header-statusText"
                    sort-key="status" sortable>
                    <span data-automation="stale_dated_checks-info-table-header-statusText-label" translate>
                      STALE_DATED_CHECKS.COLUMN_STATUS
                    </span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="stale_dated_checks-info-table-column-refundDate">
                  <ukg-th style="width:9%" data-automation="stale_dated_checks-info-table-header-refundDate"
                    sort-key="refundDate" sortable>
                    <span data-automation="stale_dated_checks-info-table-header-refundDate-label" translate>
                      STALE_DATED_CHECKS.COLUMN_REFUND_DATE
                    </span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="stale_dated_checks-info-table-column-refundStatus">
                  <ukg-th style="width:6%" data-automation="stale_dated_checks-info-table-header-refundStatus"
                    sort-key="refundStatus" sortable>
                    <span class="header-container" data-automation="stale_dated_checks-info-table-header-refundStatus-label" translate>
                      STALE_DATED_CHECKS.COLUMN_REFUND_STATUS
                    </span>
                    <ukg-icon name="help" (click)="$event.stopPropagation(); refundStatusTooltip.present($event.target)"
                      data-automation="column_refund_status_tooltip_icon">
                    </ukg-icon>
                  </ukg-th>
                </ng-container>
              </tr>
            </thead>
            <tbody data-automation="data-table-body">
              <ng-container *ngFor="let payItem of records; let i = index">
                <tr>
                  <td class="check-cell"
                    data-automation="stale_dated_checks-info-table-row-paySelected">
                    <div class="checkbox">
                      <label for="{{ 'select-pay-' + payItem.id }}" translate>
                        <input data-automation="stale_dated_checks-info-table-row-paySelected-checkbox" type="checkbox"
                          id="{{ 'select-pay-' + payItem.id }}" [checked]="isPaySelected(payItem)"
                          (click)="clickPay(payItem, $event.target.checked)" />
                      </label>
                    </div>
                  </td>
                  <td data-automation="stale_dated_checks-info-table-row-displayName">
                    <span 
                      data-automation="stale_dated_checks-info-table-row-displayName-content"
                      (mouseenter)="payItemDisplayName.present($event.target)"
                      (mouseleave)="payItemDisplayName.dismiss()">
                        {{payItem?.displayName | truncate:30}}
                    </span>
                    <ukg-popover #payItemDisplayName position="top">{{payItem.displayName}}</ukg-popover>
                  </td>
                  <td data-automation="stale_dated_checks-info-table-row-employeeNumber">
                    <span 
                      (mouseenter)="payItemEmployeeNumber.present($event.target)"
                      (mouseleave)="payItemEmployeeNumber.dismiss()"
                      data-automation="stale_dated_checks-info-table-row-employeeNumber-content">
                      {{payItem?.employeeNumber | truncate:20}}
                    </span>
                    <ukg-popover #payItemEmployeeNumber position="top">{{payItem.employeeNumber}}</ukg-popover>
                  </td>
                  <td data-automation="stale_dated_checks-info-table-row-payGroup">
                    <span 
                      (mouseenter)="payItemPayGroup.present($event.target)"
                      (mouseleave)="payItemPayGroup.dismiss()"
                      data-automation="stale_dated_checks-info-table-row-payGroup-content">
                        {{payItem?.payGroup | truncate:6}}
                    </span>
                    <ukg-popover #payItemPayGroup position="top">{{payItem.payGroup}}</ukg-popover>
                  </td>
                  <td data-automation="stale_dated_checks-info-table-row-payUtcDate">
                    <span data-automation="stale_dated_checks-info-table-row-payUtcDate-content"
                      (mouseenter)="payItemPayDate.present($event.target)"
                      (mouseleave)="payItemPayDate.dismiss()">
                        {{payItem?.payUtcDate | ultishortdate: 'L'}}
                    </span>
                    <ukg-popover #payItemPayDate position="top">{{payItem.payUtcDate | ultishortdate: 'L'}}</ukg-popover>
                  </td>
                  <td data-automation="stale_dated_checks-info-table-row-checkNumber">
                    <span data-automation="stale_dated_checks-info-table-row-checkNumber-content"
                      (mouseenter)="payItemCheckNumber.present($event.target)"
                      (mouseleave)="payItemCheckNumber.dismiss()"
                      class="nowrap">
                        {{payItem?.checkNumber}}
                    </span>
                    <ukg-popover #payItemCheckNumber position="top">{{payItem.checkNumber}}</ukg-popover>
                  </td>
                  <td data-automation="stale_dated_checks-info-table-row-checkAmount">
                    <span data-automation="stale_dated_checks-info-table-row-checkAmount-content"
                      (mouseenter)="payItemAmount.present($event.target)"
                      (mouseleave)="payItemAmount.dismiss()"
                      class="nowrap">
                        {{payItem?.checkAmount | ulticurrency:'1.02':undefined:true}}
                    </span>
                    <ukg-popover #payItemAmount position="top">{{payItem.checkAmount | ulticurrency:'1.02':undefined:true}}</ukg-popover>
                  </td>
                  <td data-automation="stale_dated_checks-info-table-row-staleDate">
                      <span data-automation="stale_dated_checks-info-table-row-staleDate-content"
                        (mouseenter)="payItemStaleDate.present($event.target)"
                        (mouseleave)="payItemStaleDate.dismiss()">
                          {{payItem?.staleDate | ultishortdate: 'L'}}
                      </span>
                      <ukg-popover #payItemStaleDate position="top">{{payItem?.staleDate | ultishortdate: 'L'}}</ukg-popover>
                  </td>
                  <td data-automation="stale_dated_checks-info-table-row-statusText">
                    <div data-automation="stale_dated_checks-info-table-row-statusText-content"                         
                      (mouseenter)="payItemStatus.present($event.target)"
                      (mouseleave)="payItemStatus.dismiss()"
                      class="result-content">
                        {{getStatusTextKey(payItem.status) | translate | truncate:30}}
                    </div>
                    <ukg-popover #payItemStatus position="top">{{getStatusDescriptionKey(payItem.status) | translate}}</ukg-popover>
                  </td>
                  <td data-automation="stale_dated_checks-info-table-row-refundDate">
                    <span data-automation="stale_dated_checks-info-table-row-refundDate-content"
                      (mouseenter)="payItemRefundDate.present($event.target)"
                      (mouseleave)="payItemRefundDate.dismiss()">
                        {{payItem?.refundDate | ultishortdate: 'L'}}
                    </span>
                    <ukg-popover #payItemRefundDate position="top">{{payItem.refundDate | ultishortdate: 'L'}}</ukg-popover>
                  </td>
                  <td data-automation="stale_dated_checks-info-table-row-refundStatus">
                    <span data-automation="stale_dated_checks-info-table-row-refundStatus-content"
                      (mouseenter)="payItemRefundDescription.present($event.target)"
                      (mouseleave)="payItemRefundDescription.dismiss()">
                        {{getRefundStatusTextKey(payItem?.refundStatus) | translate}}
                    </span>
                    <ukg-popover #payItemRefundDescription position="top">{{getRefundStatusDescriptionKey(payItem?.refundStatus) | translate}}</ukg-popover>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </ukg-data-table>
        <ukg-paginator id="paginator" data-automation="paginator" (ukgPageChanged)="onPaginatorChanged($event)"
          [rowsPerPage]="initialrowsPerPage" [totalItems]="dataCount" [rowsOptions]="rowsOptions" translate>
        </ukg-paginator>
      </ukg-data-table-container>
    </div>
  </div>
</div>

<ukg-popover #staleDateTooltip type="custom">
  <span>
    <p data-automation="column_stale_date_tooltip_text" translate>
      STALE_DATED_CHECKS.COLUMN_STALE_DATE_TOOLTIP
    </p>
  </span>
</ukg-popover>

<ukg-popover #refundStatusTooltip type="standard">
  <span>
    <p data-automation="column_refund_status_tooltip_text" translate>
      STALE_DATED_CHECKS.COLUMN_REFUND_STATUS_TOOLTIP
    </p>
  </span>
</ukg-popover>